<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UserStat',
  props: {
    rate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '盈亏人数'
    },
    k: {
      type: String,
      default: 'user'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data, rangeTitle) {
      if (data.length <= 0) {
        this.option.series = []
        this.chart.setOption(this.option, true)
        return
      }
      const time = []
      const cdata = {}
      for (const i in data) {
        const val = data[i]
        let num = 0
        time.push(dateStrTodate(val.date))
        for (const k in val.data) {
          const val2 = val.data[k]
          const value = Math.abs(val2[this.k])
          num += value
        }
        for (const k in val.data) {
          const val2 = val.data[k]
          if (cdata[k] === undefined) {
            cdata[k] = []
          }
          const value = Math.abs(val2[this.k])
          const rate = (value / num * 100).toFixed(2)
          if (this.rate) {
            cdata[k].push(rate)
          } else {
            cdata[k].push(value)
          }
        }
      }
      for (const i in cdata) {
        const val = cdata[i]
        const temp = {
          name: rangeTitle[i],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      this.option.legend.data = rangeTitle
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
